<template>
    <v-dialog v-model="loadingDialog" persistent width="300">
        <v-card>
            <v-card-text class="text-center pa-5">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
                <div class="mt-3">{{ loadingMessage }}</div>
            </v-card-text>
        </v-card>
    </v-dialog>
    <returnButton />
    <div class="main-container">
        <div class="title-header">
            <h1 class="title">{{ isEditMode ? 'Editar diagnóstico' : 'Información médica de consulta' }}</h1>
        </div>
        <div class="content-container">
            <v-row>
                <v-col cols="12" md="4">
                    <div
                        style="
                            align-items: center;
                            display: flex;
                            height: 200px;
                        ">
                        <patientInfo
                            :selectedPatientId="selectedPatientId"
                            @update-weight="recibirPeso"
                            @update-height="recibirEstatura"
                            :activeInput="true"
                            style="align-self: center; width: 100%" />
                    </div>

                    <!-- Contenedor de disease -->
                    <div class="tags-container">
                        <span class="diseasefont"> Diagnóstico : </span>
                        <div
                            v-for="(disease, index) in diseaseMap"
                            :key="index"
                            :class="{
                                'tag-disease': disease.diseaseId,
                                'tag-custom': !disease.diseaseId,
                            }">
                            <span>{{ disease.diseaseName }}</span>
                            <button
                                @click="removeTag(index)"
                                class="delete-button">
                                ×
                            </button>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" md="8">
                    <h2
                        class="titulos"
                        style="
                            text-align: center;
                            font-size: 15pt;
                            color: var(--celeste-electrico);
                            font-family: var(--font-body);
                            font-weight: bold;
                        ">
                        <v-icon style="font-size: 17pt"
                            >mdi mdi-note-text-outline</v-icon
                        >
                        Observaciones médicas
                    </h2>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-textarea
                                style="font-family: var(--font-body)"
                                v-model="note"
                                label="Nota(s)"
                                variant="outlined"
                                rows="6"
                                no-resize
                                no-gutters
                                :rules="reglasValidacion"
                                rounded="lg"
                                required />
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-end">
                        <v-checkbox
                            style="
                                margin-top: -20px;
                                margin-right: 20px;
                                font-family: 'Trebuchet MS';
                            "
                            color="var(--celeste-electrico)"
                            v-model="diagnosticDisease"
                            label="Escribir diagnóstico personalizado"
                            hide-details />
                    </v-row>
                    <v-row style="position: relative">
                        <v-col cols="12" md="12" class="pa-2">
                            <v-text-field
            style="font-family: var(--font-body)"
            v-model="findDisease"
            :loading="loadingDisease"
            variant="outlined"
            rounded="md"
            :label="searchFieldLabel"
            @click:append-inner="searchDisease()"
            @keyup.enter="searchDisease()"
            outlined
            hide-details>
            <template #append-inner>
                <v-icon
                    style="color: var(--celeste-electrico)"
                    @click="searchDisease()">
                    {{ searchIcon }}
                </v-icon>
            </template>
        </v-text-field>
                        </v-col>
                        <!-- Lista de resultados de disease -->
                        <div
                            v-if="diseasesContent"
                            class="disease-container" v-click-outside = "closeContainer">
                            <v-row>
                                <v-col
                                    v-for="(disease, index) in diseaseResults"
                                    :key="index"
                                    cols="12">
                                    <v-card
                                        style="
                                            cursor: pointer;
                                            font-family: var(--font-body);
                                        "
                                        @click="() => handleDisease(disease)"
                                        :class="{
                                            'selected-card':
                                                isDiseaseSelected(disease),
                                        }">
                                        <v-card-title
                                            v-html="
                                                disease.name
                                            "></v-card-title>
                                        <v-card-text>{{
                                            disease.description
                                        }}</v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </v-row>
                    <v-row
                        class="mt-6"
                        style="
                            margin: 10px 0;
                            gap: 20px;
                            flex-direction: row-reverse;
                        ">
                        <v-tooltip
                            :disabled="isValidDiseaseMap && note != ''"
                            :text="getMissingFieldsMessage"
                            location="top">
                            <template v-slot:activator="{ props }">
                                <button
                                    class="button boton-principal font"
                                    @click="crearReceta()"
                                    style="margin-right: 10px"
                                    :disabled="!isValidDiseaseMap || !note"
                                    v-bind="props">
                                    <v-icon left>mdi-pill</v-icon> Crear Receta
                                </button>
                            </template>
                        </v-tooltip>
                        <button
                            class="boton-principal"
                            @click="enviar_diagnostico()"
                            :disabled="!isValidDiseaseMap || !note">
                            <v-icon left>mdi-content-save</v-icon> Guardar
                        </button>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
import returnButton from '@/components/global/return-button.vue';
import patientInfo from '@/components/global/patient-info.vue';
import { postDiagnostico, putDiagnostico } from '@/api/notas';
import { getDiseases } from '@/api/consultaICD'

export default {
    components: {
        returnButton,
        patientInfo,
    },
    props: ['id', 'diagnosisId'],
    data() {
        return {
            diseaseResults: [],
            diseaseMap: [],
            selectedPatientId: '',
            findDisease: '',
            loadingDisease: false,
            diagnosticDisease: false,
            diagnosticSelected: '',
            note: '',
            appointment: '',
            loadingDialog: false,
            loadingMessage: '',
            reglasValidacion: [
                (v) => !!v || 'El campo es obligatorio',
                (v) =>
                    !v ||
                    /^[a-zA-Z0-9\sáéíóúÁÉÍÓÚñÑ,./():;]+$/.test(v) ||
                    'Solo se permiten letras, números, acentos y ,./():;',
            ],
            isExecuting: false,
            patientWeight: '',
            diseasesContent : false,
            isEditMode: false,
            originalDiagnosisId: null,
        };
    },
    created() {
        this.selectedPatientId = this.$route.params.id;
        this.practitionerId = localStorage.getItem('id-user');


        // Verificar si estamos en modo edición
        if (this.$route.query.diagnosisId && sessionStorage.getItem('diagnosisData')) {
            // Modo edición
            this.isEditMode = true;
            const diagnosisData = JSON.parse(sessionStorage.getItem('diagnosisData'));


            // Cargar los datos del diagnóstico existente
            this.note = diagnosisData.note || '';
            this.diseaseMap = diagnosisData.appointmentDiseases || [];
            this.patientWeight = diagnosisData.patient_weight || '';
            this.patientHeight = diagnosisData.patient_height || '';
            this.originalDiagnosisId = this.$route.query.diagnosisId;

            // Limpiar sessionStorage después de cargar los datos
            sessionStorage.removeItem('diagnosisData');
        }
    },
    watch: {
        diagnosticDisease() {
            if (this.diagnosticDisease) {
                this.findDisease = '';
                this.diseaseResults = [];
            } else {
                this.findDisease = '';
            }
        },
    },
    computed: {
        isValidDiseaseMap() {
            return (
                this.diseaseMap?.length > 0 &&
                this.diseaseMap.every(
                    (disease) => disease && Object.keys(disease).length > 0,
                )
            );
        },
        getMissingFieldsMessage() {
            let message = 'Campos pendientes: ';
            let missingFields = [];

            if (!this.isValidDiseaseMap) {
                missingFields.push('Diagnóstico');
            }

            if (!this.note) {
                missingFields.push('Nota clínica');
            }

            return message + missingFields.join(', ');
        },
         searchIcon() {
        return this.diagnosticDisease ? 'mdi-plus' : 'mdi-magnify';
    },
    searchFieldLabel() {
        return this.diagnosticDisease ? 'Escribir diagnóstico personalizado' : 'Buscar diagnóstico';
    },
    },
    methods: {
        searchDisease() {
            if (!this.diagnosticDisease) {
                if (this.loadingDisease) return;

                this.loadingDisease = true;
                const startTime = Date.now();

                getDiseases(this.findDisease)
                    .then((response) => {
                        if (response?.message?.length) {
                            this.diseaseResults = response.message.map(
                                (item) => ({
                                    id: item.id,
                                    description: item.description,
                                    name: item.name,
                                }),
                            );
                            this.diseasesContent = true;
                        } else {
                            this.diseaseResults = [];
                        }
                    })
                    .catch((error) => {
                        console.error('Error al buscar enfermedades:', error);
                        this.errorMessage = 'Error al cargar enfermedades';
                        this.diseaseResults = [];
                    })
                    .finally(() => {
                        const minLoadTime = 1000 - (Date.now() - startTime);
                        setTimeout(
                            () => {
                                this.loadingDisease = false;
                            },
                            minLoadTime > 0 ? minLoadTime : 0,
                        );
                    });
            } else {
                this.handleDisease(this.findDisease);
            }
        },
        handleDisease(disease) {
            if (!(typeof disease === 'string')) {
                const temporalName = disease.name.replace(/<[^>]*>/g, '');

                const diseaseName =
                    temporalName.charAt(0).toUpperCase() +
                    temporalName.slice(1).toLowerCase();
                const diseaseURL = disease.id;
                const diseaseId = diseaseURL.split('/').pop();

                const exists = this.diseaseMap.some(
                    (item) =>
                        item.diseaseName.toLowerCase() ===
                        diseaseName.toLowerCase(),
                );

                if (!exists) {
                    this.diseaseMap.push({
                        diseaseName,
                        diseaseURL,
                        diseaseId,
                    });
                } else {
                    this.diseaseMap = this.diseaseMap.filter(
                        (d) => d.diseaseName !== diseaseName,
                    );
                }

                this.diseaseResults = [];
                this.findDisease = '';
            } else {
                const temporalName = disease
                    .trim()
                    .replace(/<[^>]*>/g, '')
                    .replace(/\s{2,}/g, ' ');

                const diseaseName =
                    temporalName.charAt(0).toUpperCase() +
                    temporalName.slice(1).toLowerCase();

                if (diseaseName) {
                    const exists = this.diseaseMap.some(
                        (item) =>
                            item.diseaseName.toLowerCase() ===
                            diseaseName.toLowerCase(),
                    );

                    if (!exists) {
                        this.diseaseMap.push({
                            diseaseName,
                        });
                    } else {
                        this.diseaseMap = this.diseaseMap.filter(
                            (d) => d.diseaseName !== diseaseName,
                        );
                    }

                    this.findDisease = '';
                }
            }
        },
        isDiseaseSelected(disease) {
            const diseaseName = disease.name.replace(/<[^>]*>/g, '');

            const exists = this.diseaseMap.some(
                (item) => item.diseaseName === diseaseName,
            );

            if (exists) {
                return diseaseName;
            }
        },
        removeTag(index) {
            this.diseaseMap.splice(index, 1);
        },
        openNewICDWindow() {
            window.open('https://icd.who.int/browse/2024-01/mms/es', '_blank');
        },
        async enviar_diagnostico() {
            if (this.isExecuting) {
                return;
            }

            const data = {
                diseases: this.diseaseMap,
                patient_id: `patient_models/${this.$route.params.id}`,
                practitioner_id: this.practitionerId,
                note: this.note,
                status: 'active',
                patient_weight: (this.patientWeight !== null && this.patientWeight !== undefined && this.patientWeight !== '') ? parseFloat(this.patientWeight) : null,
                patient_height: (this.patientHeight !== null && this.patientHeight !== undefined && this.patientHeight !== '') ? parseFloat(this.patientHeight) : null,
                _key: this.isEditMode ? this.$route.params.diagnosisId : undefined
            };

            try {
                this.isExecuting = true;
                this.loadingDialog = true;
                this.loadingMessage = this.isEditMode ? 'Actualizando diagnóstico...' : 'Guardando diagnóstico...';

                let response;
                if (this.isEditMode) {
                    response = await putDiagnostico(this.originalDiagnosisId, data);
                } else {
                    response = await postDiagnostico(data);
                    this.appointment = response.data.data[0].appointment_id;
                }

                if (response.status === 200) {
                    this.resetForm();
                }

                this.$router.push({
                    name: 'Expediente',
                    params: { id: this.$route.params.id },
                });
            } catch (error) {
                console.error('Error al enviar la solicitud:', error);
            } finally {
                this.isExecuting = false;
                this.loadingDialog = false;
            }
        },
        resetForm() {
            this.diseaseResults = [];
            this.diseaseMap = [];
            this.selectedPatientId = '';
            this.findDisease = '';
            this.loadingDisease = false;
            this.diagnosticDisease = false;
            this.diagnosticSelected = '';
            this.note = '';
            this.dialog = false;
        },
        recibirPeso({ value }) {
            this.patientWeight = (value !== null && value !== undefined && value !== '') ? parseFloat(value) : null;
        },
        recibirEstatura({ value }) {
            this.patientHeight = (value !== null && value !== undefined && value !== '') ? parseFloat(value) : null;
        },
        crearReceta() {
            this.enviar_diagnostico()
                .then(() => {
                    sessionStorage.setItem(
                        'tempAppointmentId',
                        this.appointment,
                    );
                    this.$router.push({
                        name: 'CrearReceta',
                        params: { id: this.$route.params.id },
                    });
                })
                .catch((error) => {
                    console.error('Error al enviar diagnóstico:', error);
                });
        },
    closeContainer() {
      this.diseasesContent = false;
    },
    },
};
</script>
<style scoped>
.custom-textarea .v-field__outline {
    border-radius: 15pt !important;
}

.diseasefont {
    font-family: var(--font-body);
    font-size: 16pt;
}

.tag-custom {
    background-color: var(--celeste-electrico);
    padding: 5px;
    border-radius: 8px;
    font-family: var(--font-body);
    font-size: 14pt;
    color: white;
}

.tag-disease {
    background-color: #cccccc;
    padding: 5px;
    border-radius: 8px;
    font-family: var(--font-body);
    font-size: 14pt;
}
.disease-container {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 250px;
    overflow-y: auto;
    overflow-x: hidden;
    background: white;
    z-index: 10;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
}

.tags-container {
    max-height: 300px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
</style>
